import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'bulma/css/bulma.css'
import '@fortawesome/fontawesome-free/css/all.css'
import Oruga from '@oruga-ui/oruga-next'
import '@oruga-ui/oruga-next/dist/oruga.css'
import VTooltip from 'v-tooltip'

const app = createApp(App)

app.use(VTooltip)
app.use(Oruga)
app.use(router)

app.mount('#app')
